import { useEffect, useState } from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import useUser from 'stores/useCustomer';
import useCustomerActions from 'hooks/useCustomerActions';

type FavoritesProps = {
    iconProps?: IconButtonProps;
    productId: number;
};

export function Favorite({ iconProps, productId }: FavoritesProps) {
    const favourites = useUser((state) => state.favourites);
    const [isClicked, setIsClicked] = useState(false);
    const { toggleFavourite } = useCustomerActions();
    useEffect(() => {
        setIsClicked(favourites ? favourites.includes(productId) : false);
    }, [favourites, setIsClicked, productId]);

    return (
        <IconButton
            {...iconProps}
            onClick={(e) => {
                e.stopPropagation();
                toggleFavourite(productId);
            }}
        >
            {isClicked ? <FavoriteIcon color="primary" /> : <FavoriteBorderIcon color="primary" />}
        </IconButton>
    );
}
